





































interface NotificationTab {
    feature: string;
    hiddenCode: string;
    enabled?: boolean;
}

type TabKey = "request" | "socle";

import {Component, Vue, Watch} from "vue-property-decorator";
import * as Constants from "@/Constants";
import {ptfFeatures} from "@/Constants";
import Owner from "@/model/cospirit-api/Owner";
import {User} from "front-component/modules/User";
import {Getter} from "vuex-class";

@Component
export default class AdminNotificationManager extends Vue {
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getCurrentUser") public currentUser!: User;
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("getSocleModuleName") public socleModuleName!: string;

    private tabs: Record<string, NotificationTab> = {
        request: {
            feature: ptfFeatures.request,
            hiddenCode: Constants.hideFeatureNotification.hideRequest,
        },
        socle: {
            feature: ptfFeatures.socle,
            hiddenCode: Constants.hideFeatureNotification.hideSocle,
        },
    };

    private activeTab: string | null = null;

    private mounted(): void {
        this.ensureValidTab();
    }


    private created() {
        if (this.currentUser && this.currentOwner) {
            this.checkAccess();
        }
    }

    @Watch("currentOwner")
    public onCurrentOwnerChanged(): void {
        this.checkAccess();
    }

    private checkAccess(): void {
        (Object.entries(this.tabs) as Array<[TabKey, NotificationTab]>).forEach(([key, tab]) => {
            tab.enabled =
                this.hasFeature(tab.feature) &&
                !this.currentUser.userHideFeatures.find((f) => f.code === tab.hiddenCode);
        });
        this.activeTab = this.tabs.request.enabled ? "request" : this.tabs.socle.enabled ? "socle" : null;
        if (this.activeTab && this.$route.name !== `notifications_${this.activeTab}_list`) {
            this.$router.push({name: `notifications_${this.activeTab}_list`});
        }

    }

    private ensureValidTab(): void {
        const firstAvailable = (Object.entries(this.tabs) as Array<[TabKey, NotificationTab]>)
            .find(([_, tab]) => tab.enabled)?.[0];

        if (this.activeTab !== null && !this.tabs[this.activeTab]?.enabled && firstAvailable) {
            this.activeTab = firstAvailable;
        }
    }

    private onTabClick(tab: { name: string }) {
        const name = `notifications_${tab.name}_list`;
        if (this.$route.name !== name) {
            this.$router.push({name});
        }
    }
}
